import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestPageComponent } from './request-page.component';
import { RequestPageTabAcompanhamentoComponent } from './components/tabs/request-page-tab-acompanhamento/request-page-tab-acompanhamento.component';

@NgModule({
	declarations: [],
	imports: [RequestPageComponent, RequestPageTabAcompanhamentoComponent],
	exports: [RequestPageComponent, RequestPageTabAcompanhamentoComponent],
})
export class RequestPageModule {}
